import apiClient from '@/utils/apiClient';

export const updateCampaignVariables = async (
	campaign_id: string,
	variables: any,
	clientType: 'Reseller' | 'Client',
): Promise<{
	message: string;
	variables: any;
	clientType: 'Reseller' | 'Client';
}> => {
	if (!campaign_id) {
		return { message: 'Campaign ID is required', variables: [], clientType };
	}

	const response = await apiClient.request({
		method: 'PATCH',
		endPoint: `/api/novi/campaigns/${campaign_id}/updateVariables`,
		body: { variables },
		clientType: clientType === 'Reseller' ? 'RESELLER' : 'RECEPTIONIST',
	});
	return response.data;
};
